import researcherNonConfidentialTemplateService from '../services/templates/researcher_non_confidential_template.service';
import CreateFileTemplatePage from './CreateFileTemplatePage';
const ResearcherNonConfidentialTemplatePage = CreateFileTemplatePage({
  service: researcherNonConfidentialTemplateService,
  templateType: 'researcher_non_confidential_template',
  fileType: 'xlsx'
});
export default ResearcherNonConfidentialTemplatePage;